import { UserPlus, FileEdit, Share2, MessageSquare } from "lucide-react";

const steps = [
  {
    step: 1,
    title: "Crea tu cuenta",
    description: "Regístrate, elige tu plan y comienza a crear landing pages profesionales."
  },
  {
    step: 2,
    title: "Agrega tu propiedad",
    description: "Llena el formulario con fotos, descripción, precio y características."
  },
  {
    step: 3,
    title: "Personaliza tu landing",
    description: "Elige colores, agrega tracking pixels y configura tu WhatsApp."
  },
  {
    step: 4,
    title: "Comparte y recibe leads",
    description: "Publica en redes sociales y recibe prospectos directo en tu email."
  }
];

export const HowItWorks = () => {
  const icons = [UserPlus, FileEdit, Share2, MessageSquare];

  return (
    <section id="como-funciona" className="py-24 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-purple-100 text-brand-purple px-4 py-1 rounded-full text-sm font-medium mb-4">
            Proceso Simple
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            ¿Cómo <span className="text-brand-purple">Funciona</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            De cero a una landing profesional en 4 simples pasos
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection line - desktop only */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-purple-200 -z-10"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, idx) => {
              const Icon = icons[idx];
              return (
                <div
                  key={step.step}
                  className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 group"
                >
                  {/* Step number badge */}
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-brand-purple text-white rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
                    {step.step}
                  </div>

                  {/* Icon */}
                  <div className="mb-6 inline-flex p-4 bg-purple-100 rounded-xl group-hover:bg-brand-purple transition-colors duration-300">
                    <Icon className="w-8 h-8 text-brand-purple group-hover:text-white transition-colors duration-300" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom message */}
        <div className="mt-16 text-center bg-white rounded-2xl p-8 shadow-lg">
          <p className="text-lg text-gray-700 font-medium">
            <span className="text-brand-purple font-bold">Resultado:</span> Tu propiedad 
            publicada con una landing profesional en menos de 5 minutos
          </p>
        </div>
      </div>
    </section>
  );
};
